"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var instance = {};
var Settings = /** @class */ (function () {
    function Settings(theme, domain, env) {
        this.theme = theme;
        this.domain = domain;
        this.env = env;
        this.theme = theme;
        this.domain = domain;
        this.env = env;
        instance = this;
    }
    Settings.getInstance = function () {
        if (instance)
            return instance;
    };
    Settings.setup = function (theme, domain, env) {
        new Settings(theme, domain, env);
    };
    Object.defineProperty(Settings.prototype, "urlAuth", {
        get: function () {
            var url;
            switch (this.env) {
                case 'local':
                    url = 'https://devapi.mundipagg.com/auth/v2';
                    break;
                case 'staging':
                    url = 'https://stgapi.mundipagg.com/auth/v2';
                    break;
                case 'production':
                    url = 'https://api.mundipagg.com/auth/v2';
                    break;
                default:
                    url = 'https://api.mundipagg.com/auth/v2';
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Settings.prototype, "envAcronym", {
        get: function () {
            var acronym;
            switch (this.env) {
                case 'local':
                    acronym = 'local_';
                    break;
                case 'staging':
                    acronym = 'stg_';
                    break;
                case 'production':
                    acronym = '';
                    break;
                default:
                    acronym = '';
            }
            return acronym;
        },
        enumerable: false,
        configurable: true
    });
    return Settings;
}());
exports.default = Settings;
//# sourceMappingURL=Settings.js.map